export default __webpack_public_path__ + "static/media/s_processing.bc4d53df.svg";